import type { NonEmptyArray } from '@repo/types/Types';

export function assertNonEmptyArray<T>(input: T[]): NonEmptyArray<T> {
  if (input.length === 0) {
    throw new Error('Expected non-empty array is empty.');
  }
  return input as NonEmptyArray<T>;
}
